<procure-card
  condensed
  [class]="rootClass"
>
  <div class="column-overlay__content">
    <div formRow>
      <procure-input-check [control]="selectAllControl"> Select All </procure-input-check>
    </div>
    @for (column of columns; track column) {
      <div formRow>
        <procure-input-check [control]="form.controls[column]">
          {{ data.columns[column] }}
        </procure-input-check>
      </div>
    }
    <div class="column-overlay__actions">
      <button
        class="column-overlay__reset"
        procure-button
        variant="stroked"
        (click)="reset()"
      >
        Reset
      </button>
      <button
        class="column-overlay__apply"
        procure-button
        (click)="apply()"
      >
        Apply
      </button>
    </div>
  </div>
</procure-card>
